import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../redux/store";
import { fetchUserCreditBalance } from "../redux/Slices/creditSlice";

interface UserCredits {
  regular: number;
  emergency: number;
  total: number;
  isLoading: boolean;
  error: string | null;
}

export const useUserCredits = (userId?: string) => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state: any) => state.auth);
  const [credits, setCredits] = useState<UserCredits>({
    regular: 0,
    emergency: 0,
    total: 0,
    isLoading: true,
    error: null
  });

  const fetchUserCredits = async () => {
    const targetUserId = userId || user?.id;
    if (!targetUserId) {
      setCredits(prev => ({ ...prev, isLoading: false }));
      return;
    }

    try {
      setCredits(prev => ({ ...prev, isLoading: true, error: null }));
      
      // Use the same API call as ProfessionalDetailModal
      const result = await dispatch(fetchUserCreditBalance(targetUserId));
      
      if (fetchUserCreditBalance.fulfilled.match(result)) {
        const creditData = result.payload;
        setCredits({
          regular: creditData?.availableCredits || 0,
          emergency: 0, // Emergency credits not available in this API
          total: creditData?.availableCredits || 0,
          isLoading: false,
          error: null
        });
      } else {
        setCredits(prev => ({
          ...prev,
          isLoading: false,
          error: "Failed to fetch credit balance"
        }));
      }

    } catch (error: any) {
      console.error("Error fetching user credits:", error);
      setCredits(prev => ({
        ...prev,
        isLoading: false,
        error: error.message || "Failed to fetch credit balance"
      }));
    }
  };

  useEffect(() => {
    fetchUserCredits();
  }, [userId, user?.id]);

  return {
    ...credits,
    refetch: fetchUserCredits
  };
};
